import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import { Card, Modal, Button, Image } from "react-bootstrap";
import { useState, useEffect } from "react";
import Api_key from "./apiconfiguration";
import './Seriesreview.css';


const Review = ({ id, type = 'movie' }) => {
  const [reviewresult, setReviewResult] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const apiKey = Api_key;
  const wordLimit = 50;
  const [visibleReviews, setVisibleReviews] = useState(4);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const review = `https://api.themoviedb.org/3/${type}/${id}/reviews?api_key=${apiKey}&language=en-US&page=1`;
        const reviewResponse = await axios.get(review);
        setReviewResult(reviewResponse.data.results || []);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviewResult([]);
      }
    };

    fetchReviews();
  }, [id, apiKey, type]);

  const truncateText = (text, limit) => {
    const words = text.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "...";
    }
    return text;
  };

  const handleShowModal = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  const handleViewMore = () => {
    setVisibleReviews((prev) => prev + 4);
  };

  const getAvatarUrl = (avatarPath) => {
    if (avatarPath) {
      if (avatarPath.startsWith("/https")) {
        return avatarPath.substring(1);
      }
      return `https://image.tmdb.org/t/p/w200${avatarPath}`;
    }
    return "https://via.placeholder.com/50";
  };

  return (
    <div className="revmain">
    <div className="reviews-shell">
      <div className="section-heading"><div><span>COMMUNITY</span><h2>User reviews</h2></div><small>{reviewresult.length} published</small></div>
      <Row className="justify-content-center">
        {reviewresult.length > 0 ? (
          reviewresult.slice(0, visibleReviews).map((review, index) => (
            <Col xs={12} sm={6} md={4} lg={3} key={index} className="d-flex">
              <Card className="review-card">
                <div className="review-author">
                  <Image
                    src={getAvatarUrl(review.author_details.avatar_path)}
                    roundedCircle
                    className="review-avatar"
                    />
                  <div><strong>{review.author}</strong><span>{review.created_at ? new Date(review.created_at).toLocaleDateString() : 'TMDB member'}</span></div>
                </div>
                <p className="review-copy">
                  {truncateText(review.content, wordLimit)}
                </p>
                {review.content.split(" ").length > wordLimit && (
                  <Button
                  onClick={() => handleShowModal(review)}
                  className="text-button"
                  >
                    Read full review
                  </Button>
                )}
              </Card>
            </Col>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#888" }}>No reviews available.</p>
        )}
      </Row>

      {visibleReviews < reviewresult.length && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            onClick={handleViewMore}
            variant="info"
            style={{
              borderRadius: "25px",
              padding: "10px 25px",
              fontSize: "16px",
              backgroundColor: "#1e90ff",
              border: "none",
              color: "#fff",
              boxShadow: "0 4px 10px rgba(30, 144, 255, 0.3)",
            }}
            >
            View More
          </Button>
        </div>
      )}

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{ backgroundColor: "#1e1e1e", borderBottom: "1px solid #333" }}>
          <Modal.Title style={{ color: "#1e90ff" }}>Review by {selectedReview?.author}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "16px", color: "#e0e0e0", backgroundColor: "#121212", lineHeight: "1.6" }}>
          <p>{selectedReview?.content}</p>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1e1e1e", borderTop: "1px solid #333" }}>
          <Button
            variant="outline-light"
            onClick={handleCloseModal}
            style={{ borderRadius: "20px", padding: "5px 20px", color: "#fff", borderColor: "#555" }}
            >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
  );
};

export default Review;
